import CONFIG from '@/common/config.js'
import useDataStore from "@/common/store/data.js"
export const $clearAppStore = function() {
	uni.setStorageSync("userInfo",{})
	useDataStore().setUserInfo({}) 
	console.log('清除缓存::::页面缓存')
}

export const $callPhone = async (phoneNumber) => {
	phoneNumber && uni.makePhoneCall({
		phoneNumber: phoneNumber,
		success(res) {}
	});
}
export const $outLogin = (path) => {
	$clearAppStore()
	uni.$u.route({
		auth:false,
		type: 'reLaunch',
		url: '/view/login'
	})
}

export const $cdn_img = (path) => {
	// #ifdef H5
	if (path.startsWith('/static/')) return  CONFIG.$file_path  + path
	// #endif
	
	// #ifndef H5
	if (path.startsWith('/static/')) return path
	// #endif
	
	if (path.startsWith('http')) return path

	return CONFIG.$ossurl + path
}


